<ng-container *ngIf="page">
  <ng-container *ngIf="brConfig?.fundId; else previewBlock">
    <ng-container *ngIf="overviewData">
      <eds-proximal placement="FundInformationProximalTop"></eds-proximal>
      <ng-container *ngIf="gridDiv === 0 || gridDiv === 1; else twoCol">
        <div edsGrid>
          <div edsRow>
            <div edsCol [columnNumbers]="{ s: '4', l: '10' }">
              <ft-fund-information-panel
                *ngIf="overviewData.fundInformation.items.length > 0"
                [panelData]="fundInformation"
              ></ft-fund-information-panel>
              <ft-fund-information-panel
                *ngIf="overviewData.distributions.items.length > 0"
                [panelData]="distributions"
              ></ft-fund-information-panel>
              <ft-fund-information-panel
                *ngIf="overviewData.identifiers.items.length > 0 && isBrazil"
                [panelData]="identifiers"
              ></ft-fund-information-panel>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #twoCol>
        <div edsGrid>
          <div edsRow>
            <div edsCol [edsSubGrid]="gridDiv === 2 ? 'layout-1' : 'layout-3'">
              <div>
                <ft-fund-information-panel
                  *ngIf="overviewData.fundInformation.items.length > 0"
                  [panelData]="fundInformation"
                ></ft-fund-information-panel>
                <ft-fund-information-panel
                  *ngIf="
                    overviewData.distributions.items.length > 0 &&
                    !hideDividendYields
                  "
                  [panelData]="distributions"
                ></ft-fund-information-panel>
                <ft-fund-information-panel
                  *ngIf="overviewData.identifiers.items.length > 0 && isBrazil"
                  [panelData]="identifiers"
                ></ft-fund-information-panel>
              </div>
              <div>
                <ft-fund-information-panel
                  *ngIf="overviewData.salesCharges.items.length > 0"
                  [panelData]="salesCharges"
                  [chargesInfo]="chargesInfo"
                ></ft-fund-information-panel>
                <ft-fund-information-panel
                  *ngIf="overviewData.identifiers.items.length > 0 && !isBrazil"
                  [panelData]="identifiers"
                ></ft-fund-information-panel>
                <ft-fund-information-panel
                  *ngIf="overviewData.tradingCharacteristics.items.length > 0"
                  [panelData]="tradingCharacteristics"
                >
                </ft-fund-information-panel>
                <ft-fund-information-panel
                  *ngIf="
                    overviewData.temitKeyDateDetails.items.length > 0 && isTemit
                  "
                  [panelData]="temitKeyDateDetails"
                >
                </ft-fund-information-panel>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <eds-proximal placement="FundInformationProximalBottom"></eds-proximal>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #previewBlock>
  <h5>Fund Information Component</h5>
</ng-template>
